export default {

    setNewCreatedPerformance(state, value) {
        state.newCreatedPerformance = value
    },
}